import { createContext, useContext, useState, type ReactNode } from 'react';
import { useCookieConsent, type ConsentState } from '../hooks/useCookieConsent';

interface CookieConsentContextValue {
  consent: ConsentState | null;
  hasDecided: boolean;
  acceptAll: () => void;
  rejectAll: () => void;
  updateConsent: (updates: Partial<Omit<ConsentState, 'essential' | 'date'>>) => void;
  preferencesOpen: boolean;
  openPreferences: () => void;
  closePreferences: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const { consent, hasDecided, acceptAll, rejectAll, updateConsent } = useCookieConsent();
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  return (
    <CookieConsentContext.Provider value={{
      consent,
      hasDecided,
      acceptAll,
      rejectAll,
      updateConsent,
      preferencesOpen,
      openPreferences: () => setPreferencesOpen(true),
      closePreferences: () => setPreferencesOpen(false),
    }}>
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsentContext() {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error('useCookieConsentContext must be used within CookieConsentProvider');
  return ctx;
}
